var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1641 16.5655C30.1641 24.3882 23.8227 30.7295 16.0001 30.7295C8.17749 30.7295 1.83618 24.3882 1.83618 16.5655C1.83618 8.74292 8.17749 2.40161 16.0001 2.40161C23.8227 2.40161 30.1641 8.74292 30.1641 16.5655Z",
    fill: "#65AA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5121 23.4508C14.068 23.4508 13.6214 23.3102 13.2452 23.0228L7.36555 17.043C6.45771 16.35 6.28936 15.0596 6.98971 14.1611C7.68984 13.2627 8.99353 13.0961 9.90137 13.7891L14.2602 18.6081L21.4329 10.7509C22.2016 9.90894 23.5142 9.84307 24.365 10.6041C25.2157 11.3647 25.2822 12.6641 24.5134 13.506L16.0533 22.7735C15.6453 23.2204 15.0806 23.4508 14.5121 23.4508Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.e15366168892c0ba704e410d6a652e87.svg";
export { ForwardRef as ReactComponent };